/** 引入iconfont */
import { IS_LOWCODE } from "@mts/utils/env";
import "./global/iconfont.css";
import "./global/iconfont.js";
import "./menu/iconfont.css";
import "./menu/iconfont.js";

import menuIcons from "./menu/iconfont.json";

/** 可选菜单图标 */
export const MENU_ICONS = menuIcons.glyphs.map(
  (i) => `${menuIcons.css_prefix_text}${i.font_class.trim()}`
);

/** PDA可选菜单图标 */
export let PDA_MENU_ICONS: string[] = [];

if (IS_LOWCODE) {
  /** 动态引入PDA相关icons */
  async function loadPDAIcons() {
    try {
      await Promise.all([
        import("./pda/iconfont.css"),
        import("./pda/iconfont.js"),
      ]);

      const pdaIconsModule = await import("./pda/iconfont.json");
      const pdaIcons = pdaIconsModule.default || pdaIconsModule;

      if (pdaIcons && pdaIcons.glyphs) {
        PDA_MENU_ICONS = pdaIcons.glyphs
          .filter((i) => i.font_class?.startsWith("menu-"))
          .map((i) => `${pdaIcons.css_prefix_text}${i.font_class.trim()}`);
      }
    } catch (error) {
      console.warn("[IconFonts] Failed to load PDA icons:", error);
      PDA_MENU_ICONS = [];
    }
  }

  loadPDAIcons();
}
